import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export class CommunicationsListingDto {
    Id: number;
    Type: string;
    Category: string;
    Date: string;
    Site: string[];
    Study: string[];
    Significant: boolean;
    Status: string;

    constructor() { }

    matchesFilter(type: any, site: any, study: any, status: any): boolean {
        // If any filter is undefined or an empty array, return false
        if (!type || type.length === 0) return false;
        if (!site || site.length === 0) return false;
        if (!study || study.length === 0) return false;
        if (!status || status.length === 0) return false;

        // Type filter
        if (!type.includes(this.Type)) return false;
        // Site filter
        if (!DoArraysOverlap(site, this.Site)) { return false; }
        // Study filter
        if (!DoArraysOverlap(study, this.Study)) { return false; }
        // Status filter
        if (!status.includes(this.Status)) return false;

        return true;
    }
}

export class CommunicationDropdown {
    Id: number;
    Name: string;
    constructor() { }
}

export class ProjectFile {
    id: string;
    icon: string;
    link: string;
    text: string;
}

export class CommunicationAttachment {
    id: number;
    file: File;
    typeId: string;
    fileName: string;
    s3Id: string;
    otherDescription: string;
}